import Navigation from '@/components/navigation/Navigation'
import SupportComponent from '@/components/support/SupportComponent'
import TicketComponent from '@/components/support/TicketComponent'
import AppShell from '@/components/shell/AppShell'

export default [
	{
		path: '/:user_uid',
		components: {
			default: AppShell
		},
		props: {
			default: true
		},
		children: [
			{
				path: 'support/',
				name: 'Support',
				meta: {
					requiredAuth: true
				},
				components: {
					default: SupportComponent,
					menu: Navigation
				},
				props: { default: true, sidebar: true }
			},
			{
				path: 'support/:ticket_id/ticket/',
				name: 'Ticket',
				meta: {
					requiredAuth: true
				},
				components: {
					default: TicketComponent,
					menu: Navigation
				},
				props: { default: true, sidebar: true }
			}
		]
	}
]



// WEBPACK FOOTER //
// ./src/router/modules/support.js